import { mapState } from 'vuex'
import { setBodyBackground } from '@/helper'
import AppNavigation from '@/components/layout/AppNavigation'
import AppSearchBar from '@/components/layout/AppSearchBar'
import AppSettingsNavigation from '@/components/layout/AppSettingsNavigation'
import BackToTopButton from '@/components/ui/BackToTopButton'
import Chat from '@/components/overlays/Chat'
import AppBar from '@/components/layout/AppBar'

export default {
  components: {
    AppBar,
    AppNavigation,
    AppSearchBar,
    AppSettingsNavigation,
    BackToTopButton,
    Chat,
  },
  metaInfo() {
    return {
      title: this.$t('meta.title'),
      titleTemplate: this.pendingTranslations ?
        this.settings && this.settings.base_options && this.settings.base_options.meta_title :
        this.$t('meta.sub_title', { title: '%s' }),
    }
  },
  data() {
    return {
      showMainMenu: null,
      showSettingsMenu: null,
      openChat: false,
      windowSize: {
        x: 0,
        y: 0,
      },
    }
  },
  computed: {
    ...mapState('auth', [
      'user',
      'routes',
      'settings',
      'settingsRoutes',
    ]),
    ...mapState('translations', [
      'pendingTranslations',
      'pendingAvailableLanguages',
    ]),
    ...mapState('app', ['error']),
    toggleView() {
      const viewArray = [
        'login',
        'forgot-password',
        'reset-password',
        'bubbletool-tv',
      ]
      return viewArray.indexOf(this.$route.name) !== -1
    },
  },
  watch: {
    error(name) {
      if (name && name !== this.$route.name) {
        this.$router.replace({ name })
      }
    },
    windowSize({ x, y }) {
      if (x > 1264) {
        this.showSettingsMenu = false
      }
    },
  },
  mounted() {
    this.onResize()
    setInterval(this.setNoScroll, 500)
    if (this.customerConfig.images.bodyBg) {
      setBodyBackground(this.customerConfig.images.bodyBg)
    }
  },
  methods: {
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight }
    },
    setNoScroll() {
      const overlayOpen = Boolean(document.querySelector('div.v-overlay.v-overlay--active'))
      if (overlayOpen) {
        document.body.classList.add('no-scroll')
      } else {
        document.body.classList.remove('no-scroll')
      }
    },
  },
}
